// src/features/tag-types/types/index.ts

import { RaRecord } from 'react-admin';

// ============================================
// MODELOS DE DATOS
// ============================================

export interface TagType extends RaRecord {
  id: string;
  typeCode: string;
  name: string;
  description?: string;
  isSystemGenerated: boolean;
  requiresManualInput: boolean;
  createdAt: string;
}

export interface TagTypeFormData {
  typeCode: string;
  name: string;
  description?: string;
  requiresManualInput: boolean;
  isSystemGenerated: boolean;
}

export interface TagTypeValidationErrors {
  typeCode?: string;
  name?: string;
  description?: string;
}

// ============================================
// CÓDIGOS DE TIPO VÁLIDOS
// ============================================
export const VALID_TYPE_CODES = [
  { id: 'NFC_UID', name: 'NFC UID' },
  { id: 'QR_CODE', name: 'QR Code' },
  { id: 'NUMERIC_CODE', name: 'Numeric Code' },
  { id: 'AUTO_NUMERIC', name: 'Auto Numeric' },
  { id: 'BARCODE', name: 'Barcode' },
  { id: 'RFID', name: 'RFID' },
]; 

// ============================================
// UTILIDADES DE TIPO
// ============================================

export const prepareTagTypeForAPI = (data: TagTypeFormData): any => ({
  typeCode: data.typeCode.toUpperCase().replace(/\s/g, '_'),
  name: data.name,
  description: data.description || '',
  requiresManualInput: data.requiresManualInput,
  isSystemGenerated: data.isSystemGenerated,
});